import React from "react";
import { LicenseInfo } from "../../config";

const LicenseModal = () => {
  return (
    <div
      className="modal fade"
      id="licenseModal"
      tabIndex="-1"
      aria-labelledby="licenseModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title" id="licenseModalLabel">
              {LicenseInfo?.title}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body">
            <p>{LicenseInfo?.description}</p>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default LicenseModal;
